import React from 'react';
import { Link } from 'react-router-dom';
import Styled from 'styled';

import ImageView from 'lib/images/image-view';
import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import IconCamera from 'four-nets/icons/svg/icon_photo.svg';

import defaultStyles from './tag-slug.scss';
import { TagSlugFragment, ImageEdgeFragment } from './tag-slug.graphql';

export interface Props extends TagSlugFragment {
    styles: typeof defaultStyles;
}

class TagSlug extends React.PureComponent<Props> {
    render() {
        const { tag, slug, styles } = this.props;
        const link = `/inspirations/${slug}/`;

        return (
            <React.Fragment>
                <Link to={link} aria-label={slug} className={styles.link}>
                    <div className={styles.images}>
                        {tag.images
                            ? tag.images.edges.map((imgEdge: ImageEdgeFragment | null) => {
                                  const node = imgEdge && imgEdge.node;
                                  const id = node && node.id;
                                  const photoFile = node && node.photoFile;
                                  return id ? (
                                      <div key={id}>
                                          {photoFile ? (
                                              <ImageView
                                                  aspectFill={true}
                                                  srcSet={photoFile.srcset || ''}
                                                  src={photoFile.src}
                                                  sizes={{ xs: 200, md: 350 }}
                                                  linkify={false}
                                              />
                                          ) : null}
                                      </div>
                                  ) : null;
                              })
                            : null}
                    </div>
                </Link>
                <div className={styles.footer}>
                    <Link className={styles.titleLink} to={link}>
                        <p className={styles.title}>{tag.name}</p>
                    </Link>
                    <div className={styles.bottom}>
                        <div className={styles.stats}>
                            <SVGIcon className={styles.iconCamera} src={IconCamera} />
                            <span className={styles.statText}>{tag.imagesCount}</span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default Styled(defaultStyles)(TagSlug);
